import storage from 'redux-persist/lib/storage';
import {applyMiddleware, createStore} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import reducers from './state/reducers';
import {composeWithDevTools} from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import sagas from "./state/sagas";

export default (config, middlewares) => {
  const middlewaresToUse = [...middlewares];
  const sagaMiddleware = createSagaMiddleware();
  middlewaresToUse.push(sagaMiddleware);
  const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['core', 'auth', 'app'],
    ...config,
  };

  const persistedReducer = persistReducer(persistConfig, reducers);
  const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewaresToUse)));
  sagaMiddleware.run(sagas);
  const persistor = persistStore(store);
  return { store, persistor };
};
